import React, { useEffect, useState } from "react";
import MobileNumberPopup from "./MobileNumberPopup";
import AlternateButton from "../../common/buttons/AlternateButton";
import { UrlProvider } from "../../../utils/UrlProvider";
import {
  DepositApiUrlWithWWW,
  ProdDepositApiUrl,
} from "../../../utils/CalculatorUrlProvider";
import { api_base_url } from "../../../utils/ApiUrlProvider";
import ApiButton from "../../common/buttons/ApiButton";
import { useLocation } from "@gatsbyjs/reach-router";

const Calculator = ({ data, arrow_icon, buttonData, hero_images, keyword }) => {
  const [productkey, setProductKey] = useState(
    data?.[0]?.select_options?.[0]?.value
  );
  const [depositAmount, setDepositAmount] = useState(
    keyword === "Recurring Deposits" ? 100 : 1000
  );
  const [tenureYears, setTenureYears] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [tenureMonths, setTenureMonths] = useState(0);
  const [calculateData, setCalculateData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errors, setErrors] = useState("");
  const [isRegular, setIsRegular] = useState(false);

  const { MaturityValue, MaturityInterest, InterestRate } =
    calculateData !== undefined && calculateData;

  const handleInputChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    setDepositAmount(value);
    value = parseInt(value);
    if (keyword === "Fixed Deposits") {
      if (isNaN(value) || value < 1000 || value > 29999999) {
        setErrorMessage(
          "Please enter a value between ₹ 1,000 and ₹ 2,99,99,999"
        );
      } else {
        setErrorMessage("");
      }
    } else {
      if (isNaN(value) || value < 100 || value > 1499999) {
        setErrorMessage("Please enter a value between ₹ 100 and ₹ 14,99,999");
      } else {
        setErrorMessage("");
      }
    }
  };
  const handleProductkey = (e) => {
    setProductKey(e.target.value);
    setIsRegular(!isRegular);
  };
  const handleBlur = () => {
    let flag = true;
    if (tenureYears == 0 && tenureMonths == 0) {
      setErrors("Both Year and Month can't be 0");
      flag = false;
    } else {
      setErrors("");
      flag = true;
    }
    return flag;
  };

  const location = useLocation();

  const CalculateFD = async (e) => {
    e.preventDefault();
    const valid = handleBlur();
    if (errorMessage.length === 0 && valid) {
      setIsLoading(true);
      const encodedUrl = encodeURI(
        location?.href?.includes("www")
          ? DepositApiUrlWithWWW(
              productkey,
              depositAmount,
              tenureYears,
              tenureMonths
            )
          : ProdDepositApiUrl(
              productkey,
              depositAmount,
              tenureYears,
              tenureMonths
            )
      );
      try {
        const response = await fetch(encodedUrl, {
          method: "GET",
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setCalculateData(data);
        setIsLoading(false);
        setShowResult(true);
        // setIsModalOpen(true);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false); // Ensure loading state is reset on error
      }
    }
  };

  // const closeModal = () => {
  //   setIsModalOpen(false);
  // };
  // const showEmiResult = () => {
  //   setIsModalOpen(false);
  //   setShowResult(true);
  // };
  return (
    <div className="flex justify-between">
      {showResult == false ? (
        <div className="font-krubSemibold md:text-[1.3vw] text-[3.5vw] leading-tight md:w-[60%] w-[95%]">
          {/* Product Select Section */}
          <div className="md:my-[1.5vw] my-[3vw]">
            <span style={{ color: data?.[0]?.input_label_color }}>
              {data?.[0]?.input_label}
            </span>
            <select
              id="select"
              value={productkey}
              className="text-[#2E3192]"
              style={{
                backgroundImage: `url(${UrlProvider(arrow_icon?.url)})`,
              }}
              onChange={(e) => handleProductkey(e)}
            >
              {data?.[0]?.select_options?.length > 0 &&
                data?.[0]?.select_options?.map((option, idx) => (
                  <option
                    className="font-krubMedium px-[1vw] w-[10vw]"
                    key={idx}
                    value={option?.value}
                    style={{
                      color: option?.option_color,
                      width: "10vw",
                    }}
                  >
                    {option?.option}
                  </option>
                ))}
            </select>
          </div>
          {/* Amount and Interest Select Section */}
          <div className="flex md:gap-[0.7vw] gap-[2vw] md:my-[1.5vw] my-[3vw]">
            {/* Amount Select Section */}
            <p style={{ color: data?.[1]?.input_label_color }} className="">
              {data?.[1]?.input_label}
            </p>
            <span className="md:mr-[-1vw] mr-[-2vw] font-krubSemibold text-[#2E3192]">
              ₹
            </span>
            <input
              onChange={handleInputChange}
              value={depositAmount}
              className="border-0 border-b-[2px] outline-none border-[#BCBCBC] bg-transparent md:w-[8vw] w-[20vw] font-krubSemibold text-[#2E3192] text-center"
            />
          </div>
          {errorMessage && (
            <div className="md:text-[1.05vw] md:mr-0 mr-[10vw] font-krubMedium text-[3.5vw] flex flex-row">
              {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
            </div>
          )}
          {/* Tenor Select Section */}
          <div className="md:my-[1.5vw] my-[3vw] flex">
            <span style={{ color: data?.[2]?.input_label_color }}>
              {data?.[2]?.input_label}
            </span>
            <div>
              <select
                id="select"
                value={tenureYears}
                className="text-[#2E3192]"
                style={{
                  backgroundImage: `url(${UrlProvider(arrow_icon?.url)})`,
                }}
                onChange={(e) => setTenureYears(e.target.value)}
                onBlur={handleBlur}
                required
              >
                {/* <option value={0}>Select Years</option> */}
                {data?.[2]?.select_options?.length > 0 &&
                  data?.[2]?.select_options?.map((option, idx) => (
                    <option
                      className="font-krubMedium md:text-[1.3vw] px-[1vw] text-[3vw] w-[10vw]"
                      key={idx}
                      value={option?.value}
                      style={{
                        color: option?.option_color,
                        width: "10vw",
                      }}
                    >
                      {option?.option}
                    </option>
                  ))}
              </select>
              {/* {errors.years && (
                <p className="text-red-500 font-krubRegular md:text-[1.05vw] text-[3vw] md:ml-[1.5vw] ml-0">
                  {errors.years}
                </p>
              )} */}
            </div>
            <div className="md:ml-[-1.5vw] ml-0">
              <select
                id="select"
                value={tenureMonths}
                className="text-[#2E3192]"
                style={{
                  backgroundImage: `url(${UrlProvider(arrow_icon?.url)})`,
                }}
                onChange={(e) => setTenureMonths(e.target.value)}
                onBlur={handleBlur}
                required
              >
                {/* <option value={0}>Select Months</option> */}
                {data?.[3]?.select_options?.length > 0 &&
                  data?.[3]?.select_options?.map((option, idx) => (
                    <option
                      className={`font-krubMedium md:text-[1.3vw] px-[1vw] text-[3vw] w-[10vw] ${
                        tenureYears == 0 && idx == 0
                          ? "hidden"
                          : tenureYears == 10 && idx != 0
                          ? "hidden"
                          : "visible"
                      }`}
                      key={idx}
                      value={option?.value}
                      style={{
                        color: option?.option_color,
                        width: "10vw",
                      }}
                    >
                      {option?.option}
                    </option>
                  ))}
              </select>
              {/* {errors.months && (
                <p className="text-red-500 font-krubRegular md:text-[1.05vw] text-[3vw] md:ml-[1.5vw] ml-[2vw]">
                  {errors.months}
                </p>
              )} */}
            </div>
          </div>
          <div className="md:mt-[-1vw]">
            {errors && (
              <p
                style={{ color: "red" }}
                className="font-krubMedium md:text-[1.05vw] text-[3.5vw] md:ml-[2.5vw] ml-0"
              >
                {errors}
              </p>
            )}
          </div>
          {/* Calculate Button */}
          <div className="w-fit md:py-[1vw] py-[2vw]" onClick={CalculateFD}>
            <ApiButton
              label={isLoading ? "Calculating..." : buttonData?.lable}
              background_color={buttonData?.background_color}
              label_color={buttonData?.lable_color}
            />
          </div>
          {/* <MobileNumberPopup
            IsOpen={isModalOpen}
            CloseModal={closeModal}
            emiResult={showEmiResult}
          /> */}
        </div>
      ) : (
        //======= Result of Calculator ========//
        <div className="bg-white rounded-3xl p-[1.5vw] md:w-[70%] w-[95%] md:mt-[1vw] mt-[3vw]">
          <div className="md:w-[85%] w-[90%] mx-[5%] md:py-0 py-[2vw] ">
            <p className="md:my-[0.5vw] my-[2vw] md:text-[1.05vw] text-[3vw] font-krubSemibold">
              You Invest
            </p>
            <div className="bg-[#ffe66859] p-[0.5vw] px-[3vw] md:rounded-md rounded-lg">
              <span className="md:text-[1.3vw] text-[3.5vw] text-[#2E3192] font-krubSemibold">
                ₹ {depositAmount}
              </span>
              <span className="md:mx-[0.5vw] mx-[1.5vw] md:text-[0.9vw] text-[3vw] font-krubMedium">
                For
              </span>
              <span className="md:text-[1.3vw] text-[3.5vw] text-[#2E3192] font-krubSemibold">
                {tenureYears} years and {tenureMonths} months
              </span>
            </div>
          </div>
          <div className="md:w-[82%] w-[90%] mx-[5%]">
            <p className="md:my-[0.5vw] my-[2vw] md:text-[1.05vw] text-[3vw] font-krubSemibold">
              You Get
            </p>
            <div className="bg-[#ffe66859] grid md:grid-cols-3 grid-cols-2 gap-[3vw] md:p-[1vw] p-[2vw] md:px-[2vw] px-[3vw] md:rounded-md rounded-xl">
              <div>
                <p className="md:text-[0.9vw] text-[3vw] font-krubMedium">
                  Maturity amount
                </p>
                <p className="md:text-[1.3vw] text-[3.5vw] text-[#2E3192] font-krubSemibold">
                  ₹ {MaturityValue}
                </p>
              </div>
              <div>
                <p className="md:text-[0.9vw] text-[3vw] font-krubMedium">
                  Your gains
                </p>
                <p className="md:text-[1.3vw] text-[3.5vw] text-[#2E3192] font-krubSemibold">
                  ₹ {MaturityInterest}
                </p>
              </div>
              <div>
                <p className="md:text-[0.9vw] text-[3vw] font-krubMedium">
                  Interest rate
                </p>
                <p className="md:text-[1.3vw] text-[3.5vw] text-[#2E3192] font-krubSemibold">
                  {InterestRate}% p.a
                </p>
              </div>
            </div>
          </div>
          <div className="md:flex flex-none gap-[1.5vw] mx-[5%] md:mt-[1.5vw] mt-[2.5vw]">
            <div>
              <AlternateButton
                label={"Invest Now"}
                labelColor={"#FFFFFF"}
                bgColor={"#F58220"}
                href={
                  keyword === "Recurring Deposits"
                    ? "https://corporate.suryodaybank.com/suryoday-fd-account/?LG=WEBSITE"
                    : "/apply"
                }
                product_list={keyword}
              />
            </div>
            <div
              className="md:py-0 py-[2vw]"
              onClick={() => setShowResult(!showResult)}
            >
              <button
                className={`w-full bg-[#FFFFFF] rounded-full text-[#F58220] border border-[#F58220] lg:px-[2em] md:px-[2vw] xs:px-[8vw] lg:py-[1.5vh] xs:py-[1vh] md:text-[2vw] lg:text-[1vw] xs:text-[3.5vw] font-krubMedium`}
              >
                <span className="text-center">Calculate Again</span>
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="absolute md:block hidden w-[55%] right-[-5vw] bottom-0">
        {isRegular ? (
          <img
            src={UrlProvider(hero_images?.[1]?.hero_image?.url)}
            alt={"hero Image"}
            className="h-[30vw] ml-[5vw]"
          />
        ) : (
          <img
            src={UrlProvider(hero_images?.[0]?.hero_image?.url)}
            alt={"hero Image"}
            className=""
          />
        )}
      </div>
      <div className="absolute w-[100%] md:hidden flex justify-center bottom-0 right-[2vw]">
        {isRegular ? (
          <img
            src={UrlProvider(hero_images?.[1]?.hero_image?.url)}
            alt={"hero Image"}
            className="h-[60vw]"
          />
        ) : (
          <img
            src={UrlProvider(hero_images?.[0]?.hero_image?.url)}
            alt={"hero Image"}
            className="h-[60vw]"
          />
        )}
      </div>
    </div>
  );
};

export default Calculator;
